import React, {useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Spinner from "reactjs-simple-spinner";
import TextField from "@material-ui/core/TextField";
import SettingsService from "../../../services/SettingsService";
import {MenuItem} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#ffffff',
        padding: "2%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '33.33%',
    },
    smallColumn: {
        flexBasis: '20.00%',
        margin: 2
    },
    bigColumn: {
        flexBasis: '60.00%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

const FormSettings = (props) => {


    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [reason, setReason] = useState('');

    const [reasons, setReasons] = useState([]);


    useEffect(() => {
        setLoading(true);
        setUpdateLoading(false);
        setDeleteLoading(false);
        setReason('')
        SettingsService.getReasons()
            .then(res => {
                console.log(res)
                if (res === undefined) {
                    setReasons([])
                    setLoading(false)
                }
                setReasons(res.data.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setReasons([])
                setLoading(false)
            })
    }, []);

    const handleDelete = (id) => {
        setDeleteLoading(true);
        console.log(id);

        SettingsService.deleteReason(id)
            .then(res => {
                console.log("res: ", res)
                if (res.status === 200) {
                    SettingsService.getReasons().then(response => {
                        console.log(response);
                        if (response === undefined) {
                            toast.warning('✅ Reason Deleted, 🚫 Failed to get new data ', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            setDeleteLoading(false);
                        }
                        setReasons(response.data.data);
                        toast('✅ Reason Deleted! ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setDeleteLoading(false);

                        //   console.log();                                                                                        );
                    }).catch(err => {
                        console.log(err);
                        setReasons([])
                        toast.warning('✅ Reason Deleted, 🚫 Failed to get new data ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setDeleteLoading(false);
                    });

                } else {
                    toast.warning('🚫 Failed to add reason: ' + res.response.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setDeleteLoading(false);
                }
            })
            .catch(err => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to delete reason: ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setDeleteLoading(false);
            })
    }

    const addReason = () => {
        setUpdateLoading(true);

        console.log(reason);
        const payload = {
            "reason": reason
        }


        console.log("request payload: ", payload);

        SettingsService.addReason(payload).then(res => {
            console.log("res: ", res)
            if (res.status === 200) {
                SettingsService.getReasons().then(response => {
                    console.log(response);
                    if (response === undefined) {
                        toast.warning('✅ Reason added, 🚫 Failed to get new data ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setUpdateLoading(false);
                    }
                    setReasons(response.data.data);
                    toast('✅ Reason Added! ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);

                    //   console.log();                                                                                        );
                }).catch(err => {
                    console.log(err);
                    setReasons([])
                    toast.warning('✅ Reason Added, 🚫 Failed to get new data ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                });
                setReason('')
            } else {
                toast.warning('🚫 Failed to add reason: ' + res.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            }
        })
            .catch((err) => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to add reason: ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })

    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Same as */}
            <ToastContainer/>

            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content"
                className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            <Link to="/settings"><a href><i className="fa fa-cog"/>&nbsp;Settings</a></Link>
                            &nbsp;|&nbsp;
                            <span className="upper-class">Form Settings</span>
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="content-panel">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {updateLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Updating Form Settings,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {deleteLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Deleting, Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}

                                    {!loading && !updateLoading && !deleteLoading && (
                                        <>
                                            <div className="row mb-5">
                                                <div className="col-md-3"/>
                                                <div className="col-md-3"/>
                                            </div>
                                            <div className={classes.root}>
                                                <h4 className="title h4">Reasons For Withdrawal</h4>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Reasons</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Enter New Reason"
                                                                type="text"
                                                                fullWidth
                                                                value={reason}
                                                                onChange={(e) => setReason(e.target.value)}

                                                            />
                                                            <hr/>

                                                            <div className="row mt-2">
                                                                <ol className="list-group">
                                                                    {reasons.map((reason, i) => (
                                                                        <li className="list-group-item">{reason.reason} &nbsp;
                                                                            <span className="text-danger"
                                                                                  style={{cursor: "pointer"}}
                                                                                  onClick={() => handleDelete(reason.id)}><i
                                                                                className="fas fa-trash"></i></span>
                                                                        </li>
                                                                    ))}

                                                                </ol>
                                                            </div>

                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={addReason}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Submit&nbsp;
                                                                <i className="fa fa-check-circle"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                            </div>
                                        </>

                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FormSettings;
